<template>
    <div
        v-if="hasErrors"
        v-bind:id="validationErrorId"
        aria-live
        data-test-role="validation-error"
        class="col-12 element-validation-feedback row gx-3"
        v-bind:style="highSpecificityStyling">
        <div
            v-for="(error, index) in errorArray"
            v-bind:key="index"
            class="col-12">
            {{ error }}
        </div>
    </div>
</template>
<script>
    import { globalGenerator } from "Util/uniqueIdGenerator";
    export default {
        props: {
            validationError: { type: [String, Array], required: false, default: null },
            validationGroupId: { type: String, required: false, default: null }
        },
        computed: {
            hasErrors() {
                return Array.isArray(this.validationError)
                    ? this.validationError.length > 0
                    : Boolean(this.validationError);
            },
            errorArray() {
                return Array.isArray(this.validationError) ? this.validationError : [this.validationError];
            },
            // We want classes that add "!important" to override this (e.g., "mt-0"), but also want
            //  to ensure that specificity is high enough to override other classes that might be
            //  applied to the same element. Inline styles are the most specific, so we use that here.
            highSpecificityStyling() {
                return {
                    marginTop: "-1rem"
                };
            },
            validationErrorId() {
                const validationGroupIdInternal =
                    this.validationGroupId || globalGenerator.getNextId("validationerror");
                return `${validationGroupIdInternal}-validation-error`;
            }
        }
    };
</script>
<style lang="scss" scoped>
    .element-validation-feedback {
        width: 100%;
        font-size: 1rem;
        font-weight: bold;
        color: var(--bs-danger);
    }
</style>
